import { all } from "@redux-saga/core/effects";
import { watchGetResults } from "./watchGetResults";
// import { watchPrintResults } from "./watchPrintResults";

export default function* dataSaga() {
    yield all([
        watchGetResults(),
        // watchPrintResults()
    ])
}